class NoteTemplatePresenter {
  constructor(templateData) {
    this.uuid = templateData?.uuid;
    this.name = templateData?.name;
    this.content = templateData?.content;
    this.completed_at = templateData?.completed_at;
  }

  getUUID() {
    return this.uuid;
  }

  getName() {
    return this.name;
  }

  getContent() {
    return this.content;
  }

  getCompletedAt() {
    return this.completed_at;
  }

  hasContent() {
    return this.content !== null && this.content !== undefined && this.content.trim() !== '';
  }

  getDisplayName() {
    return this.name || 'Untitled Template';
  }

  getPreview() {
    if (this.hasContent()) {
      return this.content.length > 200 
        ? this.content.substring(0, 200) + '...' 
        : this.content;
    }
    return 'No content available';
  }

  isReady() {
    // Template is ready when it has content
    return this.hasContent();
  }
}

export default NoteTemplatePresenter;
